<template>
  <div class="cpt-bind-carousel">
    <div class="carousel-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item, index) in slides" :key="index">
          <div class="carousel-tag" v-if="item.tag">
            <div class="tag-text">
              {{ item.tag }}
            </div>
            <div class="tag-bg-pic">
              <img v-src="'https://imgheybox.max-c.com/oa/2025/02/19/8e42b78a4d0f931f24b10fb1adf381df.png'" alt="" />
            </div>
          </div>
          <div class="pic">
            <img v-src="item.img" alt="" />
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import Swiper, { Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.min.css';
Swiper.use([Pagination, Autoplay]);

export default {
  props: {
    slides: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    initSwiper() {
      new Swiper('.carousel-container', {
        slidesPerView: 'auto',
        centeredSlides: true,
        slideToClickedSlide: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        spaceBetween: -50,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        loop: true,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.cpt-bind-carousel {
  .carousel-container {
    padding-bottom: 20px;
    position: relative;
  }

  .swiper-slide {
    opacity: 0.4;
    width: 271px;
    height: 178px;
    border-radius: 12px;
    padding: 4px;
    border: 0.5px solid rgba(255, 255, 255, 0.2);
    background: linear-gradient(225deg, #265350 0%, #5b7662 36.62%, #9c9060 75.81%, #8e8c3e 98.43%);
    transition: opacity 300ms cubic-bezier(0, 0, 0.58, 1);
    .carousel-tag {
      visibility: hidden;
    }
    &.swiper-slide-active {
      opacity: 1;
      z-index: 100;
      scale: 1;
      .carousel-tag {
        visibility: visible;
      }
    }

    &.swiper-slide-prev {
      scale: 0.75;
    }
    &.swiper-slide-next {
      scale: 0.75;
    }

    .pic {
      width: 100%;
      height: 100%;
      img {
        width: 263px;
        height: 170px;
        border-radius: 8px;
      }
    }
  }

  .swiper-pagination {
    bottom: -3px;

    /deep/ .swiper-pagination-bullet {
      width: 8px;
      height: 2px;
      margin: 0 6px;
      border-radius: 1px;
      background: rgba(255, 255, 255, 0.4);

      &.swiper-pagination-bullet-active {
        background: rgba(255, 255, 255);
      }
    }
  }
}
</style>
